import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { classtingLogo } from '../../../../assets';

const S = {
  Header: styled.header`
    display: flex;
    align-items: center;
    padding: 12px 16px;
    /* background-color: #ffffff; */
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.12);
  `,
  Title: styled.h1`
    overflow: hidden;
    width: 136px;
    height: 0;
    padding-top: 32px;
    background: url(${classtingLogo}) no-repeat;
    background-size: 100%;
  `,
};

const Header = () => (
  <S.Header>
    <Link to="/">
      <S.Title>
        Classting
      </S.Title>
    </Link>
  </S.Header>
);

export default Header;
